import { realGbp, fullDate } from "@/lib/format";
import { Receipt } from "lucide-react";

export default function PaymentHistory({ history }) {
  return (
    <div className="mm-glow-card p-6" data-testid="payment-history">
      <div className="flex items-center gap-2.5">
        <span className="h-10 w-10 rounded-xl bg-[#00C896]/15 flex items-center justify-center text-[#00C896]"><Receipt className="h-5 w-5" /></span>
        <h3 className="font-display text-lg font-semibold">Payment history</h3>
      </div>
      <div className="mt-4 divide-y divide-white/6">
        {history.map((h) => (
          <div key={h.session_id} data-testid={`payment-row-${h.session_id}`} className="flex items-center justify-between gap-3 py-3 text-sm">
            <div className="min-w-0">
              <p className="font-medium">Premium {h.plan === "yearly" ? "Yearly" : "Monthly"}{h.kind === "renewal" ? " · renewal" : ""}</p>
              <p className="text-[11px] text-slate-500">{fullDate(h.created_at)}</p>
            </div>
            <div className="flex items-center gap-2.5 shrink-0">
              <span className="font-num font-semibold">{realGbp(h.amount_paid ?? h.amount)}</span>
              <span className={`text-[10px] px-1.5 py-0.5 rounded-full border ${h.payment_status === "paid" ? "border-[#00C896]/30 bg-[#00C896]/10 text-[#00C896]" : "border-white/15 text-slate-400"}`}>{h.payment_status}</span>
            </div>
          </div>
        ))}
        {history.length === 0 && <p data-testid="payment-history-empty" className="py-6 text-center text-sm text-slate-500">No payments yet.</p>}
      </div>
    </div>
  );
}
